module.exports = __webpack_public_path__ + "public/images/wolf.882d5b4e2d5cd7f6d56684c85ab032dd.png";